/**
 * The Agents tab's left rail (task 796).
 *
 * One card per agent the service's flow references, in the order the definition
 * declares them. The rail renders even for a single-agent service — that is the
 * common case, and the count line is itself the answer to "how many agents does
 * this service use?" — but it takes only the height its one card needs.
 */
import { AgentRailCard } from './AgentRailCard';
import type { AgentFlowEntry } from './agentFlow';

interface AgentRailProps {
  entries: AgentFlowEntry[];
  selectedAgentId: string | null;
  onSelect: (agentId: string) => void;
}

export function AgentRail({ entries, selectedAgentId, onSelect }: AgentRailProps) {
  return (
    <nav
      aria-label="Agents in this flow"
      data-testid="agent-rail"
      className="flex flex-col gap-2"
    >
      <p className="px-0.5 text-[11px] font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
        {entries.length} {entries.length === 1 ? 'agent' : 'agents'} in this flow
      </p>
      {entries.map((entry, index) => (
        <AgentRailCard
          key={entry.agentId}
          entry={entry}
          position={index + 1}
          selected={entry.agentId === selectedAgentId}
          onSelect={onSelect}
        />
      ))}
    </nav>
  );
}

export default AgentRail;
